import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { AddonPurchaseHistoryDetailComponent } from './addon-purchase-history-detail/addon-purchase-history-detail.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'vex-addon-purchase-history',
  templateUrl: './addon-purchase-history.component.html',
  styleUrls: ['./addon-purchase-history.component.scss']
})
export class AddonPurchaseHistoryComponent implements OnInit {
  addons: any = [];
  skeleton: boolean = false;
  skeletokPlaceholder: any = Array(3);

  constructor(public guiService: GuiService, private restService: RestService, public translate: TranslateService, public dialog: MatDialog) { }

  ngOnInit() {
    this.guiService.showSpinner = false;
    this.getAddons();
  }

  getAddons() {
    const body = {
      userId: this.guiService.userLogged.user.id
    }
    this.skeleton = true;
    this.restService.postService('node', '/purchase-addon-history', body).subscribe((ris) => {
      console.debug(ris);
      this.addons = ris.items;
      this.skeleton = false;
    })
  }

  openModalAddonsDetail(addons): void {
    const dialogRef = this.dialog.open(AddonPurchaseHistoryDetailComponent, {
      disableClose: true,
      panelClass: 'modal-addons-detail',
      data: {
        addons: addons
      }
    });
  }

}
